import * as React from "react";
import { forwardRef } from "react";
const SvgPlayOutline = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" ref={ref} {...props}><path fill="currentColor" fillRule="evenodd" d="m4 14.854 9.527-4.466L4 5.328v9.526ZM2 3.664v12.763a1 1 0 0 0 1.424.905l12.764-5.982a1 1 0 0 0 .044-1.789L3.47 2.781A1 1 0 0 0 2 3.663Z" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgPlayOutline);
export default ForwardRef;